module.exports = __webpack_public_path__ + "static/img/bg-id.68a43bcc.png";